/* ============================================================
   CDS — Trustoo Rating Fallback
   Studio : Chlo' Design Studio
   But    : Remplir les widgets .custom-vstar-rating-widget que
            Trustoo ne charge PAS (accueil, fiches produit, etc.)
            en appelant directement son API publique
            get_products_rating. Indépendant du "dynamic loading"
            de Trustoo. Ne touche pas aux widgets que Trustoo a
            déjà remplis (collections), pour éviter les doublons.
   ============================================================ */
(function () {
  'use strict';

  var SHOP_ID = '72498250057'; // shop_id Trustoo (vu dans l'appel API) — à changer si la boutique change
  var API = 'https://api.trustoo.io/api/v1/reviews/get_products_rating';
  var DELAY = 600; // ms — petit délai puis on remplit nos widgets (Trustoo "autres pages" désactivé)
  var BATCH = 40;   // nb de handles max par appel

  var STAR = '<svg class="cds-tr__s" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>';
  var FIVE = STAR + STAR + STAR + STAR + STAR;
  function starsHTML(rating, count) {
    var pct = Math.max(0, Math.min(100, (parseFloat(rating) || 0) / 5 * 100));
    return '<span class="cds-tr" aria-label="' + rating + '/5">' +
             '<span class="cds-tr__set">' +
               '<span class="cds-tr__row cds-tr__row--bg">' + FIVE + '</span>' +
               '<span class="cds-tr__row cds-tr__row--fg" style="width:' + pct + '%">' + FIVE + '</span>' +
             '</span>' +
             '<span class="cds-tr__n">(' + count + ')</span>' +
           '</span>';
  }

  function collect() {
    var out = [];
    var nodes = document.querySelectorAll('.custom-vstar-rating-widget[data-product-handle]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-cds-tr')) continue;                 // déjà traité
      if (el.children.length > 0) { el.setAttribute('data-cds-tr', 'trustoo'); continue; } // déjà rempli par Trustoo
      var h = el.getAttribute('data-product-handle');
      if (h) out.push({ el: el, handle: h });
    }
    return out;
  }

  function apply(items, handle, data) {
    var cnt = parseInt(data && data.total_reviews, 10) || 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle !== handle) continue;
      var el = items[i].el;
      if (el.getAttribute('data-cds-tr') === 'done') continue;
      if (el.children.length > 0) { el.setAttribute('data-cds-tr', 'trustoo'); continue; } // Trustoo a rempli entre-temps
      el.setAttribute('data-cds-tr', 'done');
      if (cnt > 0) {
        el.innerHTML = starsHTML(data.rating, cnt);
        el.classList.add('cds-tr-filled');
      } else {
        el.style.display = 'none'; // pas d'avis → on masque, pas d'espace vide
      }
    }
  }

  function fetchBatch(items, handles) {
    fetch(API + '?shop_id=' + encodeURIComponent(SHOP_ID) + '&product_handle=' + handles.map(encodeURIComponent).join(','))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || j.code !== 0 || !j.data) return;
        for (var i = 0; i < handles.length; i++) apply(items, handles[i], j.data[i]);
      })
      .catch(function () {});
  }

  function run() {
    var items = collect();
    if (!items.length) return;
    var handles = [];
    for (var i = 0; i < items.length; i++) {
      if (handles.indexOf(items[i].handle) === -1) handles.push(items[i].handle);
    }
    for (var b = 0; b < handles.length; b += BATCH) {
      fetchBatch(items, handles.slice(b, b + BATCH));
    }
  }

  function start() { setTimeout(run, DELAY); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Éditeur de thème + sections chargées dynamiquement
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 400); });

  // Styles des étoiles (injectés une fois)
  var css =
    '.cds-tr{display:inline-flex;align-items:center;line-height:0;vertical-align:middle}' +
    '.cds-tr__set{position:relative;display:inline-block;line-height:0}' +
    '.cds-tr__row{display:flex;white-space:nowrap}' +
    '.cds-tr__row--fg{position:absolute;top:0;left:0;overflow:hidden}' +
    '.cds-tr__s{width:19px;height:19px;display:block;flex:0 0 auto}' +
    '.cds-tr__row--bg .cds-tr__s path{fill:#e2e2e2;stroke:#e2e2e2;stroke-width:1.7;stroke-linejoin:round}' +
    '.cds-tr__row--fg .cds-tr__s path{fill:#FFB800;stroke:#FFB800;stroke-width:1.7;stroke-linejoin:round}' +
    '.cds-tr__n{font-size:14.5px;font-weight:600;color:#7a7a7a;margin-left:6px;white-space:nowrap}' +
    '.custom-vstar-rating-widget.cds-tr-filled{display:inline-flex;align-items:center}';
  var st = document.createElement('style');
  st.appendChild(document.createTextNode(css));
  document.head.appendChild(st);
})();
